// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuButton_menuItem__Qp9JJ","center":"MenuButton_center__eCf8I","between":"MenuButton_between__zgWoz"};